import { Component, OnInit, NgZone } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location,PlatformLocation } from "@angular/common";
import { BsModalRef, BsModalService, ModalDirective} from 'ngx-bootstrap/modal';

import { AuthService } from 'services/auth.service';
import { PreviewService } from 'aplication/preview/preview.service';
import { AnswerService } from 'student/answer/answer.service';
import { GlobalService } from 'services/global.service';

import { ConfirmationModalComponent } from 'shared/confirmation_modal/confirmation_modal.component';

@Component({
  selector: 'app-answer',
  templateUrl: './answer.component.html',
  styleUrls: ['./answer.component.css']
})
export class AnswerComponent implements OnInit {
  bsModalRef: BsModalRef;

  breadcrumbs: any[];

  questionData;
  questionId;
  courseCode; // if role == 'admin' this var value is courseFormatId else courseCode;
  choiceAnswer: any;
  textAnswer: any = "";
  isChooseQuestion : boolean;
  processing: boolean;
  imageUrl:any = "";
  isAnswered: boolean;
  answeredChoiceIs;
  isAnswerdRadio: boolean=false;
  isSubmitBeforeAnswer: boolean;
  isExceedCharLength: boolean;
  questionPosition;
  questionTotal;
  Type3=false;//非表示式
  isNextAvailable: boolean = false;
  nextQuestionId;
  prevQuestionId=-1;
  prevQuestionType=-1;
  RealNextQuestionId=-1;

  questionHelpers = new this.globalService.enumHelpers.QuestionType();
  circleNumberHelpers = new this.globalService.enumHelpers.CircleNumberType();

  constructor(
    private authService: AuthService,
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    public modalService: BsModalService,
    private previewService: PreviewService,
    private answerService: AnswerService,
    private globalService: GlobalService,
    private zone: NgZone,
    private plocation: PlatformLocation,
  ) {
    this.isChooseQuestion = true;
    this.getRoute();
    this.makingbreadcrumbs();
    if (this.authService.role == 'student') {
      this.processing = true;
      this._getStudentAnswer();
    } else if (this.authService.role == 'admin') {
      this.processing = true;
      this._getAdminAnswer();
    } else if (this.authService.role == 'courseformat_editor') {
      this.processing = true;
      this._getAdminAnswer();
    }
  }

  ngOnInit() {
    //type3用のtype3が連続だった場合にそなえての再読込
    this.route.paramMap.subscribe(paramsMap => {
      if(this.Type3){
        this.isChooseQuestion = true;
        this.Type3=false;
        this.isNextAvailable = false;
        this.nextQuestionId = null;
        
        // パラメータが変わった後の初期化処理
        this.getRoute();
        this.makingbreadcrumbs();
        if (this.authService.role == 'student') {
          this.processing = true;
          this._getStudentAnswer();
        } else if (this.authService.role == 'admin') {
          this.processing = true;
          this._getAdminAnswer();
        } else if (this.authService.role == 'courseformat_editor') {
          this.processing = true;
          this._getAdminAnswer();
        }
      }
    });

    //ブラウザバック
    /*
    this.plocation.onPopState(() => {
      if (this.authService.role != 'admin' && this.prevQuestionId!=-1) {
        console.log('backBUTTON');
        this.prevPage();
      }
    });
    */

  }

  getRoute() {
    this.courseCode = this.route.snapshot.paramMap.get('course_code');
    if (this.authService.role == 'admin' || this.authService.role == 'courseformat_editor') this.courseCode = this.route.snapshot.paramMap.get('course_format_id');
    this.questionId = this.route.snapshot.paramMap.get('question_id');
  }

  _getStudentAnswer() {
    this.answerService.getAnswer(this.authService.user.id, this.courseCode, this.questionId)
    .then(res => {
      if(res.prev_qid){
        this.prevQuestionId=res.prev_qid;
      }else{
        this.prevQuestionId=0;
      }
      if(res.prev_qtype){
        this.prevQuestionType=res.prev_qtype;
      }else{
        this.prevQuestionType=null;
      }
      if(res.next_qid){
        this.RealNextQuestionId=res.next_qid;
      }else{
        this.RealNextQuestionId=0;
      }
      this.questionData = res.question;
      this.questionPosition = res.question_position;
      this.questionTotal = res.question_total;

      if (res.question.type == this.questionHelpers.getValue('essay')) {
        this.isChooseQuestion = false;
        this.breadcrumbs[1].title = "問題";//"問題・回答画面(記述式問題)";
        this.Type3=false;
      }else if(res.question.type == this.questionHelpers.getValue('hide')){
        this.Type3=true;
        this.isChooseQuestion = false;
        this.breadcrumbs[1].title = "問題";//"問題(閲覧式)";
        if (res.next_question_id > 0) {
          this.isNextAvailable = true;
          this.nextQuestionId = res.next_question_id;
        }else{
          this.isNextAvailable = false;
          if(res.next_button_qid && res.next_button_qid > 0){
            this.nextQuestionId = res.next_button_qid;
          }else{
            this.nextQuestionId = 0;
          }
        }
      }

      if (res.have_draft) {
        this.choiceAnswer = res.draftAnswer.choice.toString();
        this.textAnswer = res.draftAnswer.answer;
      }

      if (res.answer) {
        this.isAnswered = true;
        this.textAnswer = res.answer.answer;
        this.choiceAnswer = res.answer.choice.toString();
        this.answeredChoiceIs=res.answer.choice.toString();
      }else{
        this.isAnswered = false;
      }

      this.processing = false;
      if (res.question.question_image) {
        this.imageUrl = this.globalService.getImageUrl(res.question.question_image);
      }else{
        this.imageUrl='';
      }
    })
    .catch(err => {
      this.router.navigateByUrl('/student/dashboard');
      console.log(err);
    });
  }

  

  _getAdminAnswer() {
    this.previewService.getAnswer(this.questionId,this.courseCode)
    .then(res => {
      //console.log(res);
      console.log('position:'+res.question_position+'|total:'+res.question_total);
      this.questionData = res;
      this.questionPosition = res.question_position;
      //this.questionTotal = res.group_questions;

      if(res.prev_qid){
        this.prevQuestionId=res.prev_qid;
      }else{
        this.prevQuestionId=0;
      }
      if(res.prev_qtype){
        this.prevQuestionType=res.prev_qtype;
      }else{
        this.prevQuestionType=null;
      }
      if(res.next_qid){
        this.RealNextQuestionId=res.next_qid;
      }else{
        this.RealNextQuestionId=0;
      }
      //this.questionData = res.question;
      //this.questionPosition = res.question_position;
      this.questionTotal = res.question_total;

      if (res.type == this.questionHelpers.getValue('essay')) {
        this.isChooseQuestion = false;
        this.Type3=false;
      }else if(res.type == this.questionHelpers.getValue('hide')){
        this.Type3=true;
        this.isChooseQuestion = false;
        if (this.authService.role != 'admin' && this.authService.role != 'courseformat_editor') {
          this.breadcrumbs[1].title = "問題";//"問題(閲覧式)";
        }
        if (this.RealNextQuestionId > 0) {
          this.isNextAvailable = true;
          this.nextQuestionId = this.RealNextQuestionId;
          
        }else{
          this.isNextAvailable = false;
          this.nextQuestionId = 0;
        }
      }

    if (res.question_image) {
      this.imageUrl = this.globalService.getImageUrl(res.question_image);
    }else{
      this.imageUrl = '';
    }
    this.processing = false;
    })
    .catch(err => console.log(err));
  }

  _onErrorImg() {
    this.imageUrl = "";
  }

  makingbreadcrumbs() {
    this.breadcrumbs = [
      {
        title : "ダッシュボード",
        link : "/" + this.authService.role + '/dashboard',
      },
      {
        title : "問題",
        link : "",
      },
    ];
    if (this.authService.role == 'student') {
      this.breadcrumbs[0].link = '/student/dashboard';
      this.breadcrumbs[1].title = "問題";//"問題・回答画面(選択式問題)";
    }

    if (this.authService.role == 'admin' || this.authService.role == 'courseformat_editor') {
      this.breadcrumbs.splice(1, 0, {
        title: 'コース・プレビュー',
        link: '/' + this.authService.role + "/preview/"+this.courseCode
      });
    }
  }

  saveAnswerConfirm() {
    this.isSubmitBeforeAnswer = false;
    this.isExceedCharLength = false;
    let initialState = {
      title: '送信確認',
      body: 'この内容で送信してよいですか？（送信すると回答の変更が出来なくなります）',
      closeBtnName: '戻る',
      submitBtnName: '送信',
      submitBtnClassName:'btn-blue',
      routeType: 'toFeedback',
      routeUrl: "/" + this.authService.role + "/preview/" + this.courseCode + "/feedback/" + this.questionId,
      data: { answer: "", choice: "" }
    };

    if (!this.isChooseQuestion) {
      if (this.textAnswer.length > this.questionData.char_limit) {
        return this.isExceedCharLength = true;
      }
    }else if(this.isChooseQuestion){
      //選択肢問題で選択なかったら警告だすやつを追加
      if(!this.choiceAnswer || this.choiceAnswer==0){
        return this.isSubmitBeforeAnswer=true;
      }else if(this.isSubmitBeforeAnswer){
        this.isSubmitBeforeAnswer=false;
      }
    }

    if (this.authService.role == "student") {
      initialState = this._changeStudentState(initialState);
    } else {
      const previewAnswer = {
        questionId : this.questionId,
        answer: this.choiceAnswer || "essay_answer",
      }
      localStorage.setItem('preview_answer',  JSON.stringify(previewAnswer));
      initialState.data.choice = this.choiceAnswer;
      initialState.data.answer = this.textAnswer;
    }

    // *note client request: remove the validation
    // checking validation if have answer/choice or not
    // if (!initialState.data.answer && (!initialState.data.choice || initialState.data.choice == '0')) {
    //   return this.isSubmitBeforeAnswer = true;
    // }

    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, {initialState,backdrop: true,ignoreBackdropClick: true});
  }

  saveTemporarily() {
    const postData = this._getPostData();
    //console.log(postData);
    // if (!postData.answer && !postData.choice) return this.router.navigateByUrl('/student/dashboard');

    this.answerService.studentSaveDraftAnswer(postData)
    .then((res) => {
      const url = "/" + this.authService.role + "/dashboard";

      return this.router.navigateByUrl(url);
    })
    .catch(err => console.log(err));
  }

  _changeStudentState(initialState) {
    initialState.routeType = 'studentSaveAnswer'
    initialState.routeUrl = "/" + this.authService.role + "/answer/" + this.courseCode + "/" + this.questionId + "/feedback";
    initialState.data = this._getPostData();
    
    return initialState;
  }

  _getPostData() {
    const postData = {
      student_id: this.authService.user.id,
      course_code: this.courseCode,
      question_id: this.questionData.id,
      answer: "",
      choice: "",
      is_open: false,
    };
    

    if (this.questionData.type == this.questionHelpers.getValue('essay')) {
      postData.answer = this.textAnswer;
    } else {
      postData.choice = this.choiceAnswer;
    }

    return postData;
  }

  type3confirm() {
    if (true) {
      const body = {
        feedback : false
      }

      this.answerService.updateFeedback(body, this.questionId, this.courseCode)
      .then(response => console.log(response))
      .catch(err => console.log(err));
    }

    let url = "/" + this.authService.role + "/dashboard";

    if (this.authService.role == 'admin' || this.authService.role == 'courseformat_editor') {
      url = "/" + this.authService.role + "/preview/" + this.courseCode;
    }

    if (this.isNextAvailable) {
      url = "/" + this.authService.role + "/answer/" + this.courseCode + "/" + this.nextQuestionId;

      if (this.authService.role == 'admin' || this.authService.role == 'courseformat_editor') {
        url = "/" + this.authService.role + "/preview/" + this.courseCode + "/answer/" + this.nextQuestionId;
      }
    }
    if(this.authService.role=='student'){
      let initialState = {
        routeType: 'toFeedback',
        routeUrl: "",
        data: { 
          student_id: this.authService.user.id,
          course_code: this.courseCode,
          question_id: this.questionData.id,
          answer: " ",
          choice: "-1",
          is_open: false,
        }
      };
      
      //type3の場合、feedbackを挟まないので同じコンポーネントにいく。のでngOnInitでURLparamの変更を検知して再読込（type3以外は通常feedbackに一回いくので再読込が必要になはらない）
      this.studentSaveAnswer(initialState.data,url);
      
    }else{
      this.router.navigateByUrl(url);
    }
  }

  studentSaveAnswer(data,routeUrl) {
    this.answerService.studentSaveAnswer(data)
    .then((res) => {
      this.router.navigateByUrl(routeUrl);
      //this.closeModal();
    })
    .catch(err => console.log(err));
  }

  //１つ前に戻る
  prevPage(){
    let url = "/" + this.authService.role + "/dashboard";

    if (this.prevQuestionId != -1) {
      url = "/" + this.authService.role + "/answer/" + this.courseCode + "/" + this.prevQuestionId;

      if (this.authService.role == 'admin' || this.authService.role == 'courseformat_editor') {
        url = "/" + this.authService.role + "/preview/" + this.courseCode + "/answer/" + this.prevQuestionId;
      }
    }

    if(this.prevQuestionType!=3){
      url = url + '/feedback';
    }else if(this.prevQuestionType==3){
      //同コンポーネント問題があったのでとりあえずfeedbackへ
      url = url + '/feedback';
    }

    //戻ったという状態を知りたいので印をつける
    url = url + '#prevback';

    this.router.navigateByUrl(url);
  }
  //1つ進む（回答済みの場合のボタン）
  nextPage(){
    let url = "/" + this.authService.role + "/dashboard";

    if (this.questionId) {
      url = "/" + this.authService.role + "/answer/" + this.courseCode + "/" + this.questionId;

      if (this.authService.role == 'admin' || this.authService.role == 'courseformat_editor') {
        url = "/" + this.authService.role + "/preview/" + this.courseCode + "/answer/" + this.questionId;
      }
    }

    if(this.Type3){
      //そのままつぎへ
      if (this.RealNextQuestionId) {
        url = "/" + this.authService.role + "/answer/" + this.courseCode + "/" + this.RealNextQuestionId;
  
        if (this.authService.role == 'admin' || this.authService.role == 'courseformat_editor') {
          url = "/" + this.authService.role + "/preview/" + this.courseCode + "/answer/" + this.RealNextQuestionId;
        }
      }else if (this.nextQuestionId) {
        url = "/" + this.authService.role + "/answer/" + this.courseCode + "/" + this.nextQuestionId;
  
        if (this.authService.role == 'admin' || this.authService.role == 'courseformat_editor') {
          url = "/" + this.authService.role + "/preview/" + this.courseCode + "/answer/" + this.nextQuestionId;
        }
      }
    }else{
      url = url + '/feedback';
    }

    this.router.navigateByUrl(url);
  }

  progressTagValue(questionPosition,questionTotal){
    var perVal=((questionPosition-1)/questionTotal);
    if(perVal<=0){
      perVal=0.05;
    }
    perVal = perVal*100;
    return Math.floor(perVal)+'%';
  }

  radioChanged($event){
    if(this.isAnswered){
      if($event.target.defaultValue){
        if(this.answeredChoiceIs != $event.target.defaultValue){
          this.isAnswerdRadio=true;
          this.choiceAnswer=this.answeredChoiceIs;
        }else{
          this.isAnswerdRadio=false;
        }
        //console.log(this.answeredChoiceIs);
        //console.log($event.target.defaultValue);
      }
    }
  }

  ngOnDestroy() {
    if (this.bsModalRef) this.bsModalRef.hide();

    /*
    this.plocation.onPopState=function () {
      //history.go(0);
    };
    */
  }
}



// WEBPACK FOOTER //
// ./src/app/component/shared/answer_component/answer.component.ts